import { toast } from "react-toastify";
import * as api from "../../api/api";
import { userDetails } from "../type";
import { getCustodianLimits, setUserDetails, setUserWallet } from "./auth";
import {
  deductCustodianAppealFee,
  deductUserAppealFee,
  deductUserDiputedFee,
} from "../../service/contractActions";
import { EarningRole } from "../type/userDetails";
import { getWrappedBalances } from "../../service/alacrityService";
import ToastifyIconComponent from "../../components/Common/ToastifyIconComponent";
import { parseUser, setStoredUser, setStoredWallet } from "../../utils/storedUser";

export const setSocketInstance = (payload) => ({
  type: userDetails.SET_SOCKET_INSTANCE,
  payload,
});

export const setUserPersonalDetails = (payload) => ({
  type: userDetails.SET_USER_PERSONAL_DETAILS,
  payload,
});

export const setCollateralSubmitted = (payload) => ({
  type: userDetails.SET_COLLATERAL_SUBMITTED,
  payload,
});

export const setUserBankDetails = (payload) => ({
  type: userDetails.SET_USER_BANK_DETAILS,
  payload,
});

export const setPersonalCheck = (payload) => ({
  type: userDetails.SET_USER_PERSONAL_CHECK,
  payload,
});

export const setBankCheck = (payload) => ({
  type: userDetails.SET_USER_BANK_CHECK,
  payload,
});

export const setDepositOrders = (payload) => ({
  type: userDetails.SET_DEPOSIT_ORDERS,
  payload,
});

export const setWithdrawOrders = (payload) => ({
  type: userDetails.SET_WITHDRAW_ORDERS,
  payload,
});

export const setOrdersHistory = (payload) => ({
  type: userDetails.SET_ORDERS_HISTORY,
  payload,
});

export const setViewOrderStatus = (payload) => ({
  type: userDetails.SET_VIEW_ORDER,
  payload,
});

export const setTransactionApproval = (payload) => ({
  type: userDetails.SET_APPROVED_TRANSACTION,
  payload,
});

export const setTransactionByTransactionId = (payload) => ({
  type: userDetails.SET_TRANSACTION_BY_TRANSACTION_ID,
  payload,
});

export const setRewards = (payload) => ({
  type: userDetails.SET_USER_REWARDS,
  payload,
});

export const setPasswordUpdate = (payload) => ({
  type: userDetails.SET_PASSWORD_UPDATE,
  payload,
});

export const setUpdateUserPersonalDetails = (payload) => ({
  type: userDetails.UPDATE_USER_PERSONAL_DETAILS,
  payload,
});

export const setUserBanks = (payload) => ({
  type: userDetails.SET_USER_BANKS,
  payload,
});

export const setAddNewBank = (payload) => ({
  type: userDetails.SET_ADD_NEW_BANK,
  payload,
});

export const setDeleteBank = (payload) => ({
  type: userDetails.DELETE_BANK,
  payload,
})

export const setCreateRegion = (payload) => ({
  type: userDetails.SET_CREATE_REGION,
  payload,
});

export const setAddRegionBank = (payload) => ({
  type: userDetails.SET_REGION_BANK,
  payload,
});

export const setCreateOrder = (payload) => ({
  type: userDetails.SET_CREATE_ORDER,
  payload,
});

export const setCreateOrderCheck = (payload) => ({
  type: userDetails.SET_CREATE_ORDER_STATUS,
  payload,
});

export const setConfirmOrder = (payload) => ({
  type: userDetails.SET_CONFIRM_ORDER,
  payload,
});

export const setSuccessMessage = (payload) => ({
  type: userDetails.SUCCESS_MESSAGE,
  payload,
});

export const setUploadVideo = (payload) => ({
  type: userDetails.SET_UPLOAD_VIDEO,
  payload,
});

export const setUserDepositOrders = (payload) => ({
  type: userDetails.SET_USER_DEPOSIT_ORDERS,
  payload,
});

export const setUserWithdrawOrders = (payload) => ({
  type: userDetails.SET_USER_WITHDRAW_ORDERS,
  payload,
});

export const setUserWalletDetails = (payload) => ({
  type: userDetails.SET_USER_WALLET_DETAILS,
  payload,
});

export const setDepositOrderLoader = (payload) => ({
  type: userDetails.SET_DEPOSIT_ORDER_LOADER,
  payload,
});

export const setWithdrawOrderLoader = (payload) => ({
  type: userDetails.SET_WITHDRAW_ORDER_LOADER,
  payload,
});

export const setHistoryLoader = (payload) => ({
  type: userDetails.SET_HISTORY_LOADER,
  payload,
});

export const setSettingsLoader = (payload) => ({
  type: userDetails.SET_SETTINGS_LOADER,
  payload,
});

export const setChatMessages = (payload) => ({
  type: "userDetails.SET_CHAT",
  payload,
});

export const setCreateChatRoom = (payload) => ({
  type: userDetails.SET_CHAT_ROOM,
  payload,
});

export const setSendMessage = (payload) => ({
  type: userDetails.SET_SEND_MESSAGE,
  payload,
});

export const resetUserState = () => ({
  type: userDetails.RESET_USER_STATE,
});

export const setDefaultBank = (payload) => ({
  type: userDetails.SET_DEFAULT_BANK,
  payload,
});

export const setTickerData = (payload) => ({
  type: userDetails.SET_TICKER_DATA,
  payload,
});

export const setChangeLoginCredential = (payload) => ({
  type: userDetails.SET_CHANGE_LOGIN_CREDENTIAL,
  payload,
});

export const setDisputedDepositOrders = (payload) => ({
  type: userDetails.SET_DISPUTED_DEPOSIT_ORDERS,
  payload,
});

export const setDisputedWithdrawOrders = (payload) => ({
  type: userDetails.SET_DISPUTED_WITHDRAW_ORDERS,
  payload,
});

export const setOrderVote = (payload) => ({
  type: userDetails.SET_ORDER_VOTE,
  payload,
});

export const setJuryHistory = (payload) => ({
  type: userDetails.SET_JURY_HISTORY,
  payload,
});

export const setAllOrders = (payload) => ({
  type: userDetails.SET_ALL_ORDERS,
  payload,
});

export const custodianOrders = (payload) => ({
  type: userDetails.SET_CUSTODIAN_ORDERS,
  payload,
});

export const setUserUpdatedRole = (payload) => ({
  type: userDetails.SET_USER_UPDATED_ROLE,
  payload,
});

export const setUserProfilePicture = (payload) => ({
  type: userDetails.SET_USER_PROFILE_PICTURE,
  payload,
});

export const setUserAvailability = (payload) => ({
  type: userDetails.SET_USER_AVAILABILITY,
  payload,
});

export const setJuryProofRecord = (payload) => ({
  type: userDetails.SET_JURY_PROOF,
  payload,
});

export const setJuryProofRequest = (payload) => ({
  type: userDetails.SET_JURY_PROOF_REQUEST,
  payload,
});

export const setJuryProofSubmit = (payload) => ({
  type: userDetails.SET_JURY_PROOF_SUBMIT,
  payload,
});

export const setOpenOrderDispute = (payload) => ({
  type: userDetails.SET_OPEN_ORDER_DISPUTE,
  payload,
});

export const setChangeDefaultBank = (payload) => ({
  type: userDetails.SET_MAKE_DEFAULT_BANK,
  payload,
});

export const setOpenOrderAppeal = (payload) => ({
  type: userDetails.SET_OPEN_ORDER_APPEAL,
  payload,
});

export const setVoteAppealOrder = (payload) => ({
  type: userDetails.SET_VOTE_APPEAL_ORDER,
  payload,
});

export const setUserBatchEarning = (payload) => ({
  type: userDetails.SET_USER_BATCH_EARNING,
  payload,
});
export const setTransactionsJuryOrdersLive = (payload) => ({
  type: userDetails.SET_JURY_LIVE_ORDERS,
  payload,
});

export const setAppealedTransactions = (payload) => ({
  type: userDetails.SET_APPEALED_TRANSACTIONS,
  payload,
});

export const setAppealedCompleteTransactions = (payload) => ({
  type: userDetails.SET_APPEALED_COMPLETE_ORDERS,
  payload,
});

export const setCustodianPorfolio = (payload) => ({
  type: userDetails.SET_CUSTODIAN_PORTFOLIO,
  payload,
});

export const setUserPortfolio = (payload) => ({
  type: userDetails.SET_USER_PORTFOLIO,
  payload,
});

export const setCustodianDashboardData = (payload) => ({
  type: userDetails.SET_CUSTODIAN_DASHBOARD_DATA,
  payload,
});

export const setTransactionLoader = (payload) => ({
  type: userDetails.SET_TRANSACTION_BY_ID_LOADER,
  payload,
});

export const setButtonLoader = (payload) => ({
  type: userDetails.SET_BUTTON_LOADER,
  payload,
});

export const setApprovalLoader = (payload) => ({
  type: userDetails.SET_APPROVED_STATUS,
  payload,
});

export const setDisputeLoader = (payload) => ({
  type: userDetails.SET_DISPUTE_LOADER,
  payload,
});

export const setUserDashboardData = (payload) => ({
  type: userDetails.SET_USER_DASHBOARD_DATA,
  payload,
});

export const setCloseDisputeAfterJuryVotes = (payload) => ({
  type: userDetails.SET_CLOSE_DISPUTE_AFTER_JURY_VOTES,
  payload,
});

export const setUploadProofDisputeOrApepal = (payload) => ({
  type: userDetails.SET_ADD_PROOF,
  payload,
});

export const setChatWithLoader = (payload) => ({
  type: userDetails.SET_CHAT_WITH_LOADER,
  payload,
});

export const setUserBatchPortfolioData = (payload) => ({
  type: userDetails.SET_USER_BATCH_PORTFOLIO_DATA,
  payload,
});

export const setUserTotalTransfers = (payload) => ({
  type: userDetails.SET_USER_TOTAL_TRANSFERS,
  payload,
});
export const setCustTotalBatches = (payload) => ({
  type: userDetails.SET_CUST_BATCHES,
  payload,
});

export const setCustodianPoolAmount = (payload) => ({
  type: userDetails.SET_CUSTODIAN_POOL_AMOUNT,
  payload,
});

export const setCustodianRampAmount = (payload) => ({
  type: userDetails.SET_CUSTODIAN_RAMP_VALUE,
  payload,
});

export const setCustodianEarnings = (payload) => ({
  type: userDetails.SET_CUSTODIAN_EARNINGS_AMOUNT,
  payload,
});

export const setClaimAvailabeRewards = (payload) => ({
  type: userDetails.SET_CLAIM_AVAILABLE_AMOUNT,
  payload,
});

export const setStakeData = (payload) => ({
  type: userDetails.SET_ALL_STAKING_DATA,
  payload,
});

// export const setStakeDataCount = (payload) => ({
//   type: userDetails.SET_ALL_STAKING_DATA_COUNT,
//   payload,
// });

export const setStakeLoader = (payload) => ({
  type: userDetails.SET_ALL_STAKING_LOADER,
  payload,
});

export const setCardsLoader = (payload) => ({
  type: userDetails.SET_ALL_CARDS_LOADER,
  payload,
});

export const setChat = (payload) => ({
  type: userDetails.SET_CHAT,
  payload,
});

export const setUserBalance = (payload) => ({
  type: userDetails.SET_USER_BALANCE,
  payload,
});

export const fetchCountries = (countries) => ({
  type: userDetails.FETCH_COUNTRIES,
  payload: countries,
});

export const fetchStates = (states) => ({
  type: userDetails.FETCH_STATES,
  payload: states,
});

export const fetchCities = (cities) => ({
  type: userDetails.FETCH_CITIES,
  payload: cities,
});

export const getWrappedUserBalance = (curr) => async (dispatch, getState) => {
  const state = getState();
  const user = state?.Authentication?.user;
  const rpc = state?.Authentication?.rpc;
  const { alacrityName, depositCurrencies } = parseUser(user);
  // Check if curr is provided and not already present in depositCurrencies for the very first transaction
  if (curr && !depositCurrencies.includes(curr)) {
    depositCurrencies.push(curr);
  }
  const currencyBalances = {};
  if (rpc) {
    for (const currency of depositCurrencies) {
      try {
        const prefixedCurrency = `w.${currency.toLowerCase()}`; //converting it to tokenName
        const balance = await getWrappedBalances(
          alacrityName,
          prefixedCurrency,
          rpc
        );
        if (balance) {
          currencyBalances[currency] = balance;
          dispatch(setUserBalance(currencyBalances));
        }
      } catch (err) {
        console.log(`Error fetching balance for ${currency}: ${err}`);
      }
    }
  }
};

export const userPersonalDetails = (id, data) => (dispatch, getState) => {
  dispatch(setSettingsLoader(true));
  const state = getState();
  let user = parseUser(localStorage.getItem("User"));
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  // Returns the promise so the caller can react to a field-level rejection
  // (e.g. 400 INVALID_REFERRAL_CODE -> inline error on the referral field).
  return api
    .userPersonalDetails(id, data, config)
    .then((response) => {
      dispatch(setSettingsLoader(false));
      // A profile update never changes role (role is managed only via admin
      // assignRole / updateRole). The spread preserves the existing canonical
      // role; getUserDetails() below re-syncs the full user from the backend.
      user = {
        ...user,
        profileStatus: "active",
      };
      setStoredUser(user);
      localStorage.setItem("isLogout", false);
      // The referral code has now been consumed by a SUCCESSFUL signup — drop
      // the stored copy so it can't leak into an unrelated signup on this
      // browser later. Only on success: clearing it on a failed attempt would
      // destroy a valid code with no way to re-enter it.
      localStorage.removeItem("referralCode");

      dispatch(getUserDetails(id));

      dispatch(setUserPersonalDetails(response.data.message));
      toast.success(<div className="content">Profile updated successfully</div>, {
        icon: () => (<ToastifyIconComponent />),
        className: "midl-toast"
      });
      dispatch(setPersonalCheck(true));
    })
    .catch((err) => {
      dispatch(setSettingsLoader(false));
      dispatch(setPersonalCheck(false));
      console.log(err.message);
      // Re-throw a normalized error. The backend sends
      // { error: "INVALID_REFERRAL_CODE", reason, message } on a 400; anything
      // else surfaces as a generic error the caller can ignore.
      const body = err?.response?.data || {};
      const normalized = new Error(body.message || err.message);
      normalized.error = body.error;
      normalized.reason = body.reason;
      normalized.status = err?.response?.status;
      throw normalized;
    });
};

export const userBankDetails = (data) => (dispatch, getState) => {
  dispatch(setSettingsLoader(true));
  const state = getState();
  let user = parseUser(localStorage.getItem("User"));
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .userBankDetails(data, config)
    .then((response) => {
      if (!response?.data?.success) {
        toast.error(<div className="content">{response?.data?.message}</div>, {
          icon: () => (<ToastifyIconComponent />),
          className: "midl-toast",
        });
      } else {
        dispatch(setSettingsLoader(false));
        user = {
          ...user,
          bankStatus: "active",
        };

        // setStoredUser(user);
        // dispatch(setUserDetails(JSON.stringify(user)));
        // localStorage.setItem(
        //     "User Wallet",
        //     JSON.stringify(response?.data?.data?.userWallet)
        // );
        // dispatch(setUserWallet(JSON.stringify(response?.data?.data?.userWallet)));
        // dispatch(userBanks(data?.userId));
        dispatch(setBankCheck(true));
        dispatch(userBanks(data?.userId));
        toast.success(<div className="content">Bank account details added successfully</div>, {
          icon: () => (<ToastifyIconComponent />),
          className: "midl-toast"
        });
      }
    })
    .catch((err) => {
      dispatch(setSettingsLoader(false));
      dispatch(setBankCheck(false));
      console.log(err.message);
    });
};

export const allOrders = (region) => (dispatch, getState) => {
  dispatch(setDepositOrderLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .getAllOrders(region, config)
    .then((response) => {
      dispatch(setDepositOrderLoader(false));
      dispatch(setAllOrders(response?.data?.data));
    })
    .catch((err) => {
      dispatch(setDepositOrderLoader(false));
      console.log(err.message);
    });
};

export const getAllTransactions =
  (filter = 'All', pageSize, pageNumber, custodianLiveOrders) => (dispatch, getState) => {
    dispatch(setTransactionLoader(true));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    // here

    api
      .getTransactions(filter, pageSize, pageNumber, custodianLiveOrders, config)
      .then((response) => {
        dispatch(setTransactionLoader(false));
        dispatch(setAllOrders(response?.data));
      })
      .catch((err) => {
        dispatch(setTransactionLoader(false));
        console.log(err.message);
      });
  };

export const getCustodianTransactions =
  (pageSize, pageNumber, custodianLiveOrders) => (dispatch, getState) => {
    dispatch(setTransactionLoader(true));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };


    // here

    api
      .getTransactions("All", pageSize, pageNumber, custodianLiveOrders, config)
      .then((response) => {
        dispatch(setTransactionLoader(false));
        dispatch(custodianOrders(response?.data));
      })
      .catch((err) => {
        dispatch(setTransactionLoader(false));
        console.log(err.message);
      });
  };

export const getCustodianTransactionWithoutLoader =
  (pageSize, pageNumber, custodianLiveOrders) => (dispatch, getState) => {
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    // here

    api
      .getTransactions("All", pageSize, pageNumber, custodianLiveOrders, config)
      .then((response) => {
        dispatch(custodianOrders(response?.data));
      })
      .catch((err) => {
        console.log({ err });
      });
  };

export const getAllTransactionsWithoutLoader =
  (pageSize, pageNumber, custodianLiveOrders) => (dispatch, getState) => {
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    // here

    api
      .getTransactions("All", pageSize, pageNumber, custodianLiveOrders, config)
      .then((response) => {
        dispatch(setAllOrders(response?.data));
      })
      .catch((err) => {
        console.log({ err });
      });
  };

export const depositOrders =
  (showDepositOrders, region) => (dispatch, getState) => {
    dispatch(setDepositOrderLoader(true));
    // showDepositOrders = true;
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .orders(showDepositOrders, region, config)
      .then((response) => {
        dispatch(setDepositOrderLoader(false));
        dispatch(setDepositOrders(response.data.data));
      })

      .catch((err) => {
        dispatch(setDepositOrderLoader(false));
        console.log(err.message);
      });
  };

export const withdrawOrders =
  (showDepositOrders, region) => (dispatch, getState) => {
    dispatch(setWithdrawOrderLoader(true));
    // showDepositOrders = false;
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .orders(showDepositOrders, region, config)
      .then((response) => {
        dispatch(setWithdrawOrderLoader(false));
        dispatch(setWithdrawOrders(response.data.data));
      })

      .catch((err) => {
        dispatch(setWithdrawOrderLoader(false));
        console.log(err.message);
      });
  };

export const orderHistory =
  (userId, time, isCustodian) => (dispatch, getState) => {
    dispatch(setHistoryLoader(true));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .ordersHistory(userId, time, isCustodian, config)
      .then((response) => {
        dispatch(setHistoryLoader(false));
        dispatch(setOrdersHistory(response?.data?.data));
      })

      .catch((err) => {
        dispatch(setHistoryLoader(false));
        console.log(err.message);
      });
  };

export const viewOrderStatus = (socket, data) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // const result = socket.emit('acceptOrder', data, config)

  api
    .orderStatus(data, config)
    .then((response) => {
      dispatch(setConfirmOrder(true));
      dispatch(setViewOrderStatus(response.data.message));

      if (data?.orderComplete) {
        let user = parseUser(localStorage.getItem("User"));
        const id = user?._id;
        dispatch(getUserDetails(id));
      }
    })
    .catch((err) => {
      dispatch(setConfirmOrder(false));
      console.log(err.message);
    });
};

export const cancelOrder = (data) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .cancelOrder(data, config)
    .then((response) => {
      dispatch(setConfirmOrder(true));
      dispatch(setViewOrderStatus(response.data.message));

      if (data?.orderComplete) {
        let user = parseUser(localStorage.getItem("User"));
        const id = user?._id;
        dispatch(getUserDetails(id));
      }
    })
    .catch((err) => {
      dispatch(setConfirmOrder(false));
      console.log(err.message);
    });
};
export const successTransaction = (data) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .successTransaction(data, config)
    .then((response) => {
      dispatch(setConfirmOrder(true));
      dispatch(setViewOrderStatus(response.data.message));

      if (data?.orderComplete) {
        let user = parseUser(localStorage.getItem("User"));
        const id = user?._id;
        dispatch(getUserDetails(id));
      }
    })
    .catch((err) => {
      dispatch(setConfirmOrder(false));
      console.log(err.message);
    });
};

export const viewOrderDisputeStatus = (data) => (dispatch, getState) => {
  const payload = {
    disputed: data?.disputed,
    transactionId: data?.transactionId,
    cryptoNameForDisputedFee: data?.cryptoNameForDisputedFee,
  };
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .orderStatus(payload, config)
    .then(async (response) => {
      try {
        await deductUserDiputedFee(
          response?.data?.data?.disputedLockedWraped,
          data?.privateKey,
          data?.alacrityUsername,
          "feeLess"
        );
      } catch (err) {
        console.log(err);
      }
      dispatch(setConfirmOrder(true));
      dispatch(setViewOrderStatus(response.data.message));

      if (data?.orderComplete) {
        let user = parseUser(localStorage.getItem("User"));
        const id = user?._id;
        dispatch(getUserDetails(id));
      }
    })
    .catch((err) => {
      dispatch(setConfirmOrder(false));
      console.log(err.message);
    });
};

export const test = () => {
  console.log("test");
};

export const approvedTransaction = (data, socket) => (dispatch, getState) => {
  console.log("socket", socket);
  dispatch(setApprovalLoader(false));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  data.token = token;
  socket.emit("approveTransaction", data);
};

export const transactionByTransactionId =
  (transactionId) => (dispatch, getState) => {
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .getTransactionById(transactionId, config)
      .then((response) => {
        dispatch(setTransactionByTransactionId(response.data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const transactionByTransactionIdData =
  (transactionId) => (dispatch, getState) => {
    dispatch(setTransactionLoader(true));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    if (transactionId) {
      api
        .getTransactionById(transactionId, config)
        .then((response) => {
          dispatch(setTransactionByTransactionId(response.data.data));
          dispatch(setTransactionLoader(false));
        })
        .catch((err) => {
          dispatch(setTransactionLoader(false));
          console.log(err);
        });
    }
  };

export const getRewards = () => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .getUserRewards(config)
    .then((response) => {
      dispatch(setRewards(response?.data?.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updatePassowrd = (data) => (dispatch, getState) => {
  dispatch(setSettingsLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .changePassword(data, config)
    .then((response) => {
      dispatch(setSettingsLoader(false));
      dispatch(setPasswordUpdate(true));
    })
    .catch((err) => {
      dispatch(setSettingsLoader(false));
      dispatch(setPasswordUpdate(false));
    });
};

export const updateUserPersonalDetails =
  (userId, data) => (dispatch, getState) => {
    dispatch(setSettingsLoader(true));
    const state = getState();
    let user = parseUser(localStorage.getItem("User"));
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .updateUserPersonalDetails(userId, data, config)
      .then((response) => {
        dispatch(setSettingsLoader(false));
        dispatch(setUpdateUserPersonalDetails(true));
        user = {
          ...user,
          firstName: data?.firstName,
          lastName: data?.lastName,
          country: data?.country,
          state: data?.state,
          city: data?.city,
          postalCode: data?.postalCode,
        };
        setStoredUser(user);
        dispatch(setUserDetails(JSON.stringify(user)));
        setStoredWallet(response?.data?.data?.userWallet);
        dispatch(
          setUserWallet(JSON.stringify(response?.data?.data?.userWallet))
        );
      })

      .catch((err) => {
        dispatch(setSettingsLoader(false));
        dispatch(setUpdateUserPersonalDetails(false));
        console.log(err);
      });
  };

export const userBanks = (userId) => (dispatch, getState) => {
  dispatch(setSettingsLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .userBanks(userId, config)
    .then((response) => {
      dispatch(setUserBanks(response?.data?.data));
      dispatch(setSettingsLoader(false));
      // dispatch(getUserDetails(userId))
    })
    .catch((err) => {
      dispatch(setSettingsLoader(false));
    });
};

export const depositOpns = (data) => (dispatch, getState) => {
  const state = getState();
  let user = parseUser(localStorage.getItem("User"));
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .depositOPNs(data, config)
    .then((response) => {
      setStoredUser(response?.data?.data);
      dispatch(setUserDetails(JSON.stringify(response?.data?.data)));
      setStoredWallet(response?.data?.data?.userWallet);
      dispatch(setUserWallet(JSON.stringify(response?.data?.data?.userWallet)));
      toast.success(<div className="content">User collateral submission success</div>, {
        icon: () => (<ToastifyIconComponent />),
        className: "midl-toast"
      });
      dispatch(setCollateralSubmitted(true));
    })
    .catch((err) => {
      dispatch(setCollateralSubmitted(false));
    });
};

export const getUserDetails = (id) => (dispatch, getState) => {
  const state = getState();
  let user = parseUser(localStorage.getItem("User"));
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .getUserPersonalDetails(id, config)
    .then((response) => {
      const isLogout = localStorage.getItem("isLogout");

      if (isLogout === "false" || isLogout === false) {
        setStoredUser(response?.data?.data?.user);
        setStoredWallet(response?.data?.data?.userWallet);
        dispatch(
          setUserWallet(JSON.stringify(response?.data?.data?.userWallet))
        );
        dispatch(setUserDetails(JSON.stringify(response?.data?.data?.user)));
        // toast.success('User Detail Success');
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
export const updateUser = (id, data) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .updateUser(id, data, config)
    .then((response) => {
      setStoredUser(response?.data?.data);
      dispatch(setUserDetails(JSON.stringify(response?.data?.data)));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const addCollateral = (payload) => (dispatch, getState) => {
  const state = getState();
  let user = parseUser(localStorage.getItem("User"));
  dispatch(setButtonLoader(true));
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .addCollateral(payload, config)
    .then((response) => {

      if (response?.data?.status) {
        setStoredUser(response?.data?.data);
        dispatch(setUserDetails(JSON.stringify(response?.data?.data)));
        // Refresh the dashboard limit cards (parity with removeCollateral). Without this the
        // Collateral/Limit/Tied/Free cards stay stale until a manual reload.
        dispatch(getCustodianLimits());
        dispatch(setSuccessMessage(true));
        dispatch(setButtonLoader(false));
      } else {
        // Backend rejected the off-chain sync (e.g. unresolved txHash, wallet mismatch).
        // Surface it instead of silently swallowing — the on-chain tx may have succeeded while
        // the DB never updated, which is exactly the failure mode this flow used to hide.
        toast.error(
          <div className="content">
            {response?.data?.message ||
              "Collateral was sent on-chain but could not be recorded. It will sync automatically shortly, or retry."}
          </div>,
          { icon: () => <ToastifyIconComponent />, className: "midl-toast" },
        );
        dispatch(setButtonLoader(false));
      }
    })
    .catch((err) => {
      toast.error(
        <div className="content">
          {err?.response?.data?.message ||
            "Collateral was sent on-chain but could not be recorded. It will sync automatically shortly, or retry."}
        </div>,
        { icon: () => <ToastifyIconComponent />, className: "midl-toast" },
      );
      dispatch(setButtonLoader(false));
    });
};

export const removeCollateral = (payload) => (dispatch, getState) => {
  const state = getState();
  let user = parseUser(localStorage.getItem("User"));
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .removeCollateral(payload, config)
    .then((response) => {
      setStoredUser(response?.data?.data);
      if (response?.data?.status) {
        dispatch(setUserDetails(JSON.stringify(response?.data?.data)));
        dispatch(getCustodianLimits())
        dispatch(getCustodianProtfolio()); // Refresh portfolio data to update bankVault and batchAmount
        dispatch(setSuccessMessage(true));
        dispatch(setButtonLoader(false));
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch(setButtonLoader(false));
    });
};

export const deleteBank = (bankId, userId) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }
  api.deleteBank(bankId, config)
    .then(res => {
      if (res.data.success) {
        toast.success(<div className="content">Bank account deleted successfully</div>, {
          icon: () => (<ToastifyIconComponent />),
          className: "midl-toast"
        });
        dispatch(userBanks(userId))
      }
      else toast.error(<div className="content">Bank account deletion failed</div>, {
        icon: () => (<ToastifyIconComponent />),
        className: "midl-toast",
      });
    })
    .catch(err => {
      toast.error(<div className="content">Bank account deletion failed</div>, {
        icon: () => (<ToastifyIconComponent />),
        className: "midl-toast",
      });
    })
}

export const addNewBank = (data) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .userBankDetails(data, config)
    .then((response) => {
      dispatch(setAddNewBank(true));
    })
    .catch((err) => {
      console.log(err);
      dispatch(setAddNewBank(false));
    });
};

export const regionCreated =
  (userId, regionName, data) => (dispatch, getState) => {
    data = "";
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .createRegion(userId, regionName, data, config)
      .then((response) => {
        dispatch(setCreateRegion(true));
      })
      .catch((err) => {
        dispatch(setCreateRegion(false));
      });
  };

export const addRegionBank = (regionId, data) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .addRegionBank(regionId, data, config)
    .then((response) => {
      dispatch(setAddRegionBank(true));
    })
    .catch((err) => {
      dispatch(setAddRegionBank(false));
      console.log(err);
    });
};

export const createOrder = (socket, data, txId) => (dispatch, getState) => {
  dispatch(setButtonLoader(true));
  dispatch(setCreateOrderCheck(false));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  data.token = token;
  socket.emit("createOrder", data);
};

export const uploadRecordedVideo = (data) => (dispatch, getState) => {
  dispatch(setSettingsLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .uploadVideo(data, config)
    .then((response) => {
      dispatch(setSettingsLoader(false));
      dispatch(setUploadVideo(true));
      // dispatch(viewOrderStatus(data2));
      console.log("uploadRecordedVideo", response.data);
      //   dispatch(setTransactionByTransactionId(response.data.data));
      dispatch(transactionByTransactionId(response.data.data?._id));
    })
    .catch((err) => {
      dispatch(setSettingsLoader(false));
      dispatch(setUploadVideo(false));
    });
};

export const userWalletDetails = (userId) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .userWalletDetails(userId, config)
    .then((response) => {
      dispatch(setUserWalletDetails(response?.data?.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getChat =
  (userId, custodianId, transactionId) => (dispatch, getState) => {
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .getChat(userId, custodianId, transactionId, config)
      .then((response) => {
        dispatch(setChatMessages(response?.data?.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getChatFromTxId = (txId, userId) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;

  api.getChatFromTxId(txId, userId).then((res) => {
    dispatch(setChat(res.data.data.messages));
  });
};

export const updateChatReadStatus = (payload) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  console.log("API TOKEN", token);
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api.updateChatReadStatus(payload, config)
};

export const getChatWithLoader =
  (userId, custodianId, transactionId) => (dispatch, getState) => {
    dispatch(setChatWithLoader(true));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .getChat(userId, custodianId, transactionId, config)
      .then((response) => {
        dispatch(setChatWithLoader(false));
        dispatch(setChatMessages(response?.data?.data));
      })
      .catch((err) => {
        dispatch(setChatWithLoader(false));
        console.log(err);
      });
  };

export const createChatRoom = (data) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .createChatRoom(data, config)
    .then((response) => {
      dispatch(setCreateChatRoom(true));
    })
    .catch((err) => {
      dispatch(setCreateChatRoom(false));
      console.log(err);
    });
};

export const sendMessage =
  (userRole, socket, data, payload) => (dispatch, getState) => {
    console.log('send msg user details [][][]')
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    if (userRole == "user" || userRole == "jury") {
      data.id = payload.approvedBy;
    } else if (userRole == "custodian") {
      data.id = payload.userId;
    }

    data.userRole = userRole;
    data.token = token;

    const response = socket.emit("sendMessage", data);

  };

export const defaultBank =
  (userId, regionId, bankId) => (dispatch, getState) => {
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .selectedBank(userId, regionId, bankId, config)
      .then((response) => {
        dispatch(setDefaultBank(true));
      })
      .catch((err) => {
        dispatch(setDefaultBank(false));
      });
  };

export const tickerData = () => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  api
    .ticker(config)
    .then((response) => {
      dispatch(setTickerData(response?.data?.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const changeLoginCredential =
  (data, updateByEmail) => (dispatch, getState) => {
    dispatch(setChangeLoginCredential(false));
    const state = getState();
    let user = parseUser(localStorage.getItem("User"));
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .changeLoginEmailOrNumber(data, config)
      .then((response) => {
        if (updateByEmail) {
          user = {
            ...user,
            email: data?.email,
          };

          setStoredUser(user);
          dispatch(setUserDetails(JSON.stringify(user)));
          setStoredWallet(response?.data?.data?.userWallet);
          dispatch(
            setUserWallet(JSON.stringify(response?.data?.data?.userWallet))
          );
        } else {
          user = {
            ...user,
            phoneNumber: `+${data?.phoneNumber}`,
            countryCode: `+${data?.countryCode}`,
          };

          setStoredUser(user);
          dispatch(setUserDetails(JSON.stringify(user)));
          setStoredWallet(response?.data?.data?.userWallet);
          dispatch(
            setUserWallet(JSON.stringify(response?.data?.data?.userWallet))
          );
        }
        dispatch(setChangeLoginCredential(true));
      })
      .catch((err) => {
        dispatch(setChangeLoginCredential(false));
      });
  };

export const disputedDepositOrder =
  (showDepositOnly, region) => (dispatch, getState) => {
    dispatch(setDepositOrderLoader(true));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .getDisputedOrders(showDepositOnly, region, config)
      .then((response) => {
        dispatch(setDepositOrderLoader(false));
        dispatch(setDisputedDepositOrders(response?.data?.data));
      })
      .catch((err) => {
        dispatch(setDepositOrderLoader(false));
        console.log(err);
      });
  };

export const disputedWithdrawOrder =
  (showDepositOnly, region) => (dispatch, getState) => {
    dispatch(setWithdrawOrderLoader(true));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .getDisputedOrders(showDepositOnly, region, config)
      .then((response) => {
        dispatch(setWithdrawOrderLoader(false));
        dispatch(setDisputedWithdrawOrders(response?.data?.data));
      })
      .catch((err) => {
        dispatch(setWithdrawOrderLoader(false));
      });
  };

export const voteOrder = (data) => (dispatch, getState) => {
  dispatch(setOrderVote(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .giveVote(data, config)
    .then((response) => {
      dispatch(setOrderVote(false));
      dispatch(transactionByTransactionId(data?.transactionId));
    })
    .catch((err) => {
      dispatch(setOrderVote(false));
    });
};

export const juryHistory = (time, filter = 'All', pageSize, pageNumber) => (dispatch, getState) => {
  dispatch(setHistoryLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .juryHistory(time, filter, pageSize, pageNumber, config)
    .then((response) => {
      dispatch(setHistoryLoader(false));
      dispatch(setJuryHistory(response?.data));
    })
    .catch((err) => {
      dispatch(setHistoryLoader(false));
    });
};

export const updateUserRole = (id, data) => (dispatch, getState) => {
  dispatch(setUserUpdatedRole(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .updateUserRole(id, data, config)
    .then((response) => {
      dispatch(getUserDetails(id));
      dispatch(setUserUpdatedRole(false));

      setStoredUser(response?.data?.data);
      dispatch(setUserDetails(JSON.stringify(response?.data?.data)));
      // localStorage.setItem(
      //     "User Wallet",
      //     JSON.stringify(response?.data?.data?.userWallet)
      // );
      // dispatch(setUserWallet(JSON.stringify(response?.data?.data?.userWallet)));
    })
    .catch((err) => {
      dispatch(setUserUpdatedRole(false));
    });
};

export const changeProfilePicture = (data) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .updateProfilePicture(data, config)
    .then((response) => {
      setStoredUser(response?.data?.data);
      dispatch(setUserDetails(JSON.stringify(response?.data?.data)));
    })
    .catch((err) => {
      console.log("app crashing in redux", err);
    });
};

export const editUserAvailability = (data) => (dispatch, getState) => {
  dispatch(setUserAvailability(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .editAvailability(data, config)
    .then((response) => {
      dispatch(setUserAvailability(false));

      setStoredUser(response?.data?.data);
      dispatch(setUserDetails(JSON.stringify(response?.data?.data)));
      setStoredWallet(response?.data?.data?.userWallet);
      dispatch(setUserWallet(JSON.stringify(response?.data?.data?.userWallet)));
      toast.success(<div className="content">Information Updated</div>, {
        icon: () => (<ToastifyIconComponent />),
        className: "midl-toast"
      });
    })
    .catch((err) => {
      dispatch(setUserAvailability(false));
      console.log(err);
    });
};

export const juryProofRecord = (id) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .getRequestedProof(id, config)
    .then((response) => {
      dispatch(setJuryProofRecord(response?.data?.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const juryProofRequest = (data, id) => (dispatch, getState) => {
  dispatch(setJuryProofRequest(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .requestProof(data, config)
    .then((response) => {
      dispatch(juryProofRecord(id));
      dispatch(setJuryProofRequest(false));
    })
    .catch((err) => {
      dispatch(setJuryProofRequest(false));
    });
};

export const openDisputeForOrder =
  (socket, payload) => (dispatch, getState) => {
    dispatch(setOpenOrderDispute(false));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    socket.emit("openDispute", payload);
  };

export const openDisputeForOrderByCustodian =
  (socket, payload, data) => (dispatch, getState) => {
    dispatch(setOpenOrderDispute(false));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    socket.emit("openDispute", payload);
  };

export const changeDefaultBank = (userId, data) => (dispatch, getState) => {
  dispatch(setChangeDefaultBank(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .makeDefaultBanks(userId, data?._id, "", config)
    .then((response) => {
      toast.success(<div className="content">{data?.accountNo} set as default</div>, {
        icon: () => (<ToastifyIconComponent />),
        className: "midl-toast"
      });
      dispatch(setChangeDefaultBank(false));
      dispatch(setUserBanks(response?.data?.data));
    })
    .catch((err) => {
      dispatch(setChangeDefaultBank(false));
      console.log({ err });
    });
};

export const openOrderAppeal = (payload, data) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api.openOrderAppeal(payload, config).then(async (response) => {
    try {
      await deductUserAppealFee(
        response?.data?.data?.appealLockedWraped,
        data?.rpc,
        data?.alacrityUsername,
        "feeLess"
      );
      dispatch(setOpenOrderAppeal(true));
      dispatch(transactionByTransactionId(payload?.transactionId));
    } catch (err) {
      dispatch(setOpenOrderAppeal(false));
      console.log({ err });
    }
  });
};

export const openOrderAppealDisputeUser =
  (payload, data) => (dispatch, getState) => {
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api.openOrderAppeal(payload, config).then(async (response) => {
      try {
        let dispute = response?.data?.data?.disputedLockedWraped;
        let appeal = response?.data?.data?.appealLockedWraped;

        dispute = dispute?.split(" ");
        appeal = appeal?.split(" ");

        let sum = Number(dispute[0]) + Number([appeal[0]]);

        const lockedWrappedAmount = sum + " " + dispute[1];
        await deductUserAppealFee(
          lockedWrappedAmount,
          data?.rpc,
          data?.alacrityUsername,
          "feeLess"
        );
        dispatch(setOpenOrderAppeal(true));
        dispatch(transactionByTransactionId(payload?.transactionId));
        // toast.info('Total of 15 are deducted from your wallet');
      } catch (err) {
        dispatch(setOpenOrderAppeal(false));
        console.log({ err });
      }
    });
  };

export const openOrderAppealForCustodian =
  (payload, data) => (dispatch, getState) => {
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api.openOrderAppeal(payload, config).then(async (response) => {
      try {
        await deductCustodianAppealFee(
          "10.0000 OPN",
          data?.rpc,
          data?.alacrityUsername,
          "feeLess"
        );
        dispatch(setOpenOrderAppeal(true));
        dispatch(transactionByTransactionId(payload?.transactionId));
      } catch (err) {
        dispatch(setOpenOrderAppeal(false));
        console.log({ err });
      }
    });
  };

export const openOrderAppealForCustodianDisputeUser =
  (payload, data) => (dispatch, getState) => {
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api.openOrderAppeal(payload, config).then(async (response) => {
      try {
        await deductCustodianAppealFee(
          "15.0000 OPN",
          data?.privateKey,
          data?.alacrityUsername,
          "feeLess"
        );
        dispatch(setOpenOrderAppeal(true));
        dispatch(transactionByTransactionId(payload?.transactionId));
        // toast.info('Total of 15OPNS have been deducted from your wallet.');
      } catch (err) {
        dispatch(setOpenOrderAppeal(false));
        console.log({ err });
      }
    });
  };

export const voteAppealOrder = (data) => (dispatch, getState) => {
  dispatch(setVoteAppealOrder(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .voteAppealOrder(data, config)
    .then((response) => {
      dispatch(setVoteAppealOrder(false));
      dispatch(transactionByTransactionId(data?.transactionId));
    })
    .catch((err) => {
      dispatch(setVoteAppealOrder(false));
    });
};

export const userBatchEarning = (filter = 'All', pageSize, pageNumber) => (dispatch, getState) => {
  dispatch(setHistoryLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .getUserBatchEarning(config, filter, pageSize, pageNumber)
    .then((response) => {
      dispatch(setHistoryLoader(false));
      dispatch(setUserBatchEarning(response?.data));
    })
    .catch((err) => {
      dispatch(setHistoryLoader(false));
    });
};

export const getAllTransactionsJuryOrdersLive = (silent = false) => (dispatch, getState) => {
  // `silent` skips the full-table loader so live (socket/poll/focus) refreshes
  // update the table in place without flashing a spinner.
  if (!silent) dispatch(setSettingsLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .getTransactionsJuryOrdersLive(config)
    .then((response) => {
      dispatch(setTransactionsJuryOrdersLive(response?.data?.data));
      if (!silent) dispatch(setSettingsLoader(false));
    })
    .catch((err) => {
      if (!silent) dispatch(setSettingsLoader(false));
      console.log(err);
    });
};

export const appealedTransactions = (pageSize = 10, pageNumber = 1, silent = false) => (dispatch, getState) => {
  // `silent` skips the table loader so live (socket/poll/focus) refreshes update
  // the appeal table in place without flashing a spinner.
  if (!silent) dispatch(setDepositOrderLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .getApplealedTransactions(pageSize, pageNumber, config)
    .then((response) => {
      dispatch(setAppealedTransactions(response?.data));
      if (!silent) dispatch(setDepositOrderLoader(false));
    })
    .catch((err) => {
      if (!silent) dispatch(setDepositOrderLoader(false));
      console.log({ err });
    });
};

// here
export const getApplealedCompleteTransactions = (filter, pageSize, pageNumber) => (dispatch, getState) => {
  dispatch(setSettingsLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .getApplealedCompleteTransactions(filter, pageSize, pageNumber, config)
    .then((response) => {
      dispatch(setAppealedCompleteTransactions(response?.data));
      dispatch(setSettingsLoader(false));
    })
    .catch((err) => {
      dispatch(setSettingsLoader(false));
      console.log({ err });
    });
};

export const getCustodianProtfolio = (silent = false) => (dispatch, getState) => {
  // `silent` skips the portfolio-table loader so live (socket/poll/focus)
  // refreshes update the table in place without flashing a spinner.
  if (!silent) dispatch(setSettingsLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .getCustodianProtfolio(config)
    .then((response) => {
      if (!silent) dispatch(setSettingsLoader(false));
      dispatch(setCustodianPorfolio(response?.data));
    })
    .catch((err) => {
      if (!silent) dispatch(setSettingsLoader(false));
      console.log({ err });
    });
};

export const getCustodianDashboardData = () => (dispatch, getState) => {
  dispatch(setWithdrawOrderLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .getCustodianDashboardData(config)
    .then((response) => {
      dispatch(setWithdrawOrderLoader(false));
      dispatch(setCustodianDashboardData(response?.data?.data));
    })
    .catch((err) => {
      dispatch(setWithdrawOrderLoader(false));
      console.log({ err });
    });
};

export const getUserPortfolio = () => (dispatch, getState) => {
  dispatch(setSettingsLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .userPortfolio(config)
    .then((response) => {
      dispatch(setUserPortfolio(response?.data?.data));
      dispatch(setSettingsLoader(false));
    })
    .catch((err) => {
      dispatch(setSettingsLoader(false));
      console.log({ err });
    });
};

export const getUserDashboardCardData = () => (dispatch, getState) => {
  dispatch(setDepositOrderLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .userPortfolio(config)
    .then((response) => {
      dispatch(setUserDashboardData(response?.data?.data));
      dispatch(setDepositOrderLoader(false));
    })
    .catch((err) => {
      dispatch(setDepositOrderLoader(false));
      console.log({ err });
    });
};

export const getCloseDisputeAfterJuryVotes =
  (transactionId) => (dispatch, getState) => {
    dispatch(setCloseDisputeAfterJuryVotes(true));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    api
      .closeDisputeAfterJuryVotes(transactionId, {}, config)
      .then((response) => {
        if (!response?.data?.success) {
          toast.error(<div className="content">{response?.data?.message}</div>, {
            icon: () => (<ToastifyIconComponent />),
            className: "midl-toast",
          });
          return;
        }
        dispatch(setCloseDisputeAfterJuryVotes(false));
        dispatch(transactionByTransactionId(transactionId));
      })
      .catch((err) => {
        dispatch(setCloseDisputeAfterJuryVotes(false));
      });
  };

export const uploadProofDisputeOrAppeal = (payload) => (dispatch, getState) => {
  dispatch(setUploadProofDisputeOrApepal(true));
  dispatch(setDisputeLoader(true))
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .uploadProofForDisputeOrAppeal(payload, config)
    .then((response) => {
      dispatch(setUploadProofDisputeOrApepal(false));
      dispatch(setDisputeLoader(false))
      dispatch(transactionByTransactionIdData(payload?.transactionId));
    })
    .catch((err) => {
      dispatch(setUploadProofDisputeOrApepal(false));
      dispatch(setDisputeLoader(false))
    });
};

export const getUserTransferData = () => (dispatch, getState) => {
  // dispatch(setSettingsLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .userTotalTransfer(config)
    .then((response) => {
      dispatch(setUserTotalTransfers(response?.data?.data));
    })
    .catch((err) => {
      console.log({ err });
    });
};

export const getCustTotalBatches = () => (dispatch, getState) => {
  // dispatch(setSettingsLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .custTotalBatches(config)
    .then((response) => {
      dispatch(setCustTotalBatches(response?.data?.data));
    })
    .catch((err) => {
      console.log({ err });
    });
};

export const getUserBatchPortfolioData = (silent = false) => (dispatch, getState) => {
  // `silent` skips the portfolio-table loader so live (socket/poll/focus)
  // refreshes update the table in place without flashing a spinner.
  if (!silent) dispatch(setSettingsLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .userBatchPortfolioData(config)
    .then((response) => {
      dispatch(setUserBatchPortfolioData(response?.data));
      if (!silent) dispatch(setSettingsLoader(false));
    })
    .catch((err) => {
      if (!silent) dispatch(setSettingsLoader(false));
      console.log({ err });
    });
};

export const sendOrderTxId = (transactionId, txId) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .setOrderTxId(transactionId, txId, config)
    .then((response) => {
      dispatch(transactionByTransactionId(transactionId));
    })
    .catch((err) => {
      console.log({ err });
    });
};

export const getCustodianPoolDetail = (silent = false) => (dispatch, getState) => {
  // `silent` skips the cards loader so live refreshes don't flash a spinner.
  if (!silent) dispatch(setCardsLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .getCustodianPoolAmount(config)
    .then((response) => {
      dispatch(setCustodianPoolAmount(response?.data?.data));
      if (!silent) dispatch(setCardsLoader(false));
    })
    .catch((err) => {
      console.log({ err });
      if (!silent) dispatch(setCardsLoader(false));
    });
};

export const getCustodianRampAmount =
  () => (dispatch, getState) => {
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .getRampValue(config)
      .then((response) => {
        dispatch(setCustodianRampAmount(response?.data));
      })
      .catch((err) => {
        console.log({ err });
      });
  };

export const getCustodianEarnings = () => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  api
    .getCustEarnings(EarningRole.CUSTEARN, config)
    .then((response) => {
      if (response?.data?.success) {
        dispatch(setCustodianEarnings(response?.data?.data));
      }
    })
    .catch((err) => {
      console.log({ err });
    });
};

export const claimAvailbaleRewards =
  (currency, amount) => (dispatch, getState) => {
    dispatch(setClaimAvailabeRewards(false));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .claimAvailableRewards(currency, amount, config)
      .then((response) => {
        dispatch(getCustodianPoolDetail());
        dispatch(setClaimAvailabeRewards(true));
      })
      .catch((err) => {
        dispatch(setClaimAvailabeRewards(false));
        console.log({ err });
      });
  };

export const claimPoolRewards = (currency, amount) => (dispatch, getState) => {
  dispatch(setClaimAvailabeRewards(false));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .claimPoolRewards(currency, amount, config)
    .then((response) => {
      dispatch(getCustodianPoolDetail());
      dispatch(setClaimAvailabeRewards(true));
    })
    .catch((err) => {
      dispatch(setClaimAvailabeRewards(false));
      console.log({ err });
    });
};

export const claimCustodianRewardPool =
  (amount, currency, userId) => (dispatch, getState) => {
    dispatch(setClaimAvailabeRewards(false));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .claimCustodianRewardPool(amount, currency, config)
      .then((response) => {
        dispatch(getCustodianPoolDetail());
        dispatch(setClaimAvailabeRewards(true));
        dispatch(getUserDetails(userId));
      })
      .catch((err) => {
        dispatch(setClaimAvailabeRewards(false));
        console.log({ err });
      });
  };

export const claimJuryRewardPool =
  (amount, currency, userId) => (dispatch, getState) => {
    dispatch(setClaimAvailabeRewards(false));
    const state = getState();
    const token = state?.Authentication?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    api
      .claimJuryRewardPool(amount, currency, config)
      .then((response) => {
        dispatch(getCustodianPoolDetail());
        dispatch(setClaimAvailabeRewards(true));
        dispatch(getUserDetails(userId));
      })
      .catch((err) => {
        dispatch(setClaimAvailabeRewards(false));
        console.log({ err });
      });
  };

export const getAllStakingData = (pageSize, pageNumber) => (dispatch, getState) => {
  dispatch(setStakeLoader(true));
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  api
    .getAllStaking(pageSize, pageNumber, config)
    .then((response) => {
      dispatch(setStakeData(response?.data));
      dispatch(setStakeLoader(false));
      // dispatch(setStakeDataCount(response?.data?.totalCount))
    })
    .catch((err) => {
      console.log({ err });
      dispatch(setStakeLoader(false));
    });
};

export const stakingActions = (id, data, options = {}) => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const pageSize = options?.pageSize ?? 10;
  const pageNumber = options?.pageNumber ?? 1;

  api
    .stakingActions(data, config)
    .then((response) => {
      dispatch(getAllStakingData(pageSize, pageNumber));
      dispatch(getUserDetails(id));
    })
    .catch((err) => {
      console.log({ err });
    });
};


export const fetchAllCountries = () => {
  return async (dispatch) => {
    try {
      const response = await api.getAllCountries()
      dispatch(fetchCountries(response.data.data));
    } catch (error) {
      console.log({ error })
    }
  };
};

export const fetchStatesOfCountry = (countryCode) => {
  return async (dispatch) => {
    try {
      const response = await api.getStatesOfCountry(countryCode)
      // dispatch(fetchStates(response.data.data));
      return response
    } catch (error) {
      console.log({ error })
    }
  };
};

export const fetchCitiesOfCountry = (countryCode, isoCode) => {
  return async (dispatch) => {
    try {
      const response = await api.getCitiesOfCountry(countryCode, isoCode)
      // dispatch(fetchCities(response.data));
      return response
    } catch (error) {
      console.log({ error })
    }
  };
};

